module.exports = __webpack_public_path__ + "static/img/2253_phase_function_Paper_Points.2922165.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2253_phase_function_Paper_Points.png
// module id = /9Ds
// module chunks = 0